export default __webpack_public_path__ + "static/media/rocket_anim_56.50575153.png";